module.exports = __webpack_public_path__ + "static/media/sara.917f2c97.jpg";